export const resolveUrlOrigin = (value) => {
  if (!value || typeof value !== 'string') {
    return '';
  }

  try {
    return new URL(value).origin;
  } catch (error) {
    if (value.startsWith('http://') || value.startsWith('https://')) {
      const match = value.match(/^(https?:\/\/[^/]+)/i);
      if (match) {
        return match[1];
      }
    }
  }

  return '';
};

export default resolveUrlOrigin;
